var map = {
	"./1544923318981": 40,
	"./1544923318981.jpg": 40,
	"./Credits_Panama_logo": 41,
	"./Credits_Panama_logo.jpg": 41,
	"./credits_logo": 42,
	"./credits_logo.png": 42,
	"./credits_logo_2x_large": 43,
	"./credits_logo_2x_large.png": 43,
	"./credits_logo_large": 44,
	"./credits_logo_large.png": 44,
	"./credits_panama_logo": 45,
	"./credits_panama_logo.jpg": 45,
	"./favicon/favicon": 46,
	"./favicon/favicon.png": 46,
	"./logo": 47,
	"./logo.png": 47,
	"./persona-login": 48,
	"./persona-login.png": 48,
	"./rolando-signature": 49,
	"./rolando-signature.jpeg": 49,
	"./signature": 50,
	"./signature.png": 50,
	"./signatures/douglas_zuleta": 51,
	"./signatures/douglas_zuleta.jpeg": 51,
	"./signatures/edelmira_lopez": 52,
	"./signatures/edelmira_lopez.png": 52,
	"./signatures/edgar_derek": 53,
	"./signatures/edgar_derek.png": 53,
	"./signatures/maria_alejandra_estrada_arauz": 54,
	"./signatures/maria_alejandra_estrada_arauz.png": 54,
	"./signatures/maria_mendieta": 55,
	"./signatures/maria_mendieta.png": 55,
	"./yappy-logo": 56,
	"./yappy-logo.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;